import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			marginLeft: theme.spacing(-2),
			marginRight: theme.spacing(-2),
			[theme.breakpoints.up('sm')]: {
				marginLeft: theme.spacing(-3),
				marginRight: theme.spacing(-3),
			},
		},
		container: {
			marginTop: theme.spacing(-4),
			marginBottom: theme.spacing(-4),
			'& $item': {
				paddingTop: theme.spacing(4),
				paddingBottom: theme.spacing(4),
			},
		},
		item: {
			[theme.breakpoints.down('md')]: {
				maxWidth: theme.spacing(71.75),
			},
		},
		title: {
			marginBottom: theme.spacing(5),
		},
		itemRoot: {
			flexDirection: 'row',
			alignItems: 'start',
			flexWrap: 'nowrap',
		},
		image: {
			height: theme.spacing(8.7),
			width: theme.spacing(8.7),
			marginRight: theme.spacing(3.5),
			flexShrink: 0,
			[theme.breakpoints.down('sm')]: {
				marginRight: theme.spacing(2),
			},
		},
	}),
	{ name: 'Testimonials-Columns' },
)

export default useStyles
